import { render, staticRenderFns } from "./DonationInfo.vue?vue&type=template&id=9129f7a8&"
import script from "./DonationInfo.vue?vue&type=script&lang=js&"
export * from "./DonationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\webinane\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9129f7a8')) {
      api.createRecord('9129f7a8', component.options)
    } else {
      api.reload('9129f7a8', component.options)
    }
    module.hot.accept("./DonationInfo.vue?vue&type=template&id=9129f7a8&", function () {
      api.rerender('9129f7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DonationInfo.vue"
export default component.exports